import {getCoralServiceDataFromParent} from "../handler/ParentDataHandler";
import {isResponseCode5xx, logOperationalMetric} from "../util/Util";
import {ENDPOINT_GET_CART_RECIPE_BY_CART_TYPE, PROCESS_NODE_RESOURCE} from "../util/Constants";

export async function getCartRecipe(cartType) {
    let args = createRequest(PROCESS_NODE_RESOURCE, ENDPOINT_GET_CART_RECIPE_BY_CART_TYPE, {cartType: cartType});
    return await getCoralServiceDataFromParent(args, PROCESS_NODE_RESOURCE, ENDPOINT_GET_CART_RECIPE_BY_CART_TYPE);
}

export async function getCartRecipes(cartTypeList, metricProcessName) {
    const promises = [];
    const startTime = Date.now();
    const cartRecipeMap = new Map();
    if(cartTypeList) {
        cartTypeList.forEach((cartType) => {
            promises.push(getCartRecipe(cartType))
        });
    }
    const getCartRecipeResultList =  await Promise.all(promises);
    getCartRecipeResultList.forEach((getCartRecipeResult, index) => {
        if (getCartRecipeResult.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getCartRecipes", true, false);
            cartRecipeMap.set(getCartRecipeResult.data.cartRecipe.cartType, getCartRecipeResult.data.cartRecipe);
        } else {
            const isFault = isResponseCode5xx(getCartRecipeResult.status)
            logOperationalMetric(startTime, metricProcessName, "getCartRecipes", false, isFault);
        }
    });
    return cartRecipeMap;
}

export function createRequest(processName, endPoint, requestBody) {
    return {
        processName: processName,
        endPoint: endPoint,
        request: JSON.stringify(requestBody)
    }
}


// WEBPACK FOOTER //
// ./src/components/resources/NodeResource.js